import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Textarea,
} from '@fluentui/react-components';

type TProps = { open: boolean; onComment: (text: string) => void; onClose: () => void };

export const CommentFindingDialog = ({ open, onComment, onClose }: TProps) => {
  const [text, setText] = useState('');
  useEffect(() => {
    if (open) setText('');
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Comment</DialogTitle>
          <DialogContent>
            <Field label="Comment" required>
              <Textarea
                size="large"
                value={text}
                onChange={(_, data) => setText(data.value)}
                rows={4}
                resize="vertical"
              />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button appearance="primary" disabled={!text.trim()} onClick={() => onComment(text.trim())}>
              Add comment
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
